import { getSocketClient } from '../entry-socket';

const ASYNC_WS_TIMEOUT_MS = 5 * 60 * 1000;

export const generateAsyncRequestId = () =>
  (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : `req_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;

export const isCompletedTrue = (value) => value === true || value === 'true';

const getCompletedFromData = (data, msg) =>
  isCompletedTrue(data?.completed) || (typeof msg === 'object' && isCompletedTrue(msg?.completed));

export const normalizeWsPayload = (data) => {
  let payloadData = data?.eventMessage || data;
  let msg = data?.message;
  if (data?.message == null) {
    return { payloadData, displayMessage: '', isCompleted: getCompletedFromData(data, null) };
  }
  if (typeof msg === 'object') {
    payloadData = msg;
    msg = msg?.message;
  } else if (typeof msg === 'string') {
    try {
      const parsed = JSON.parse(msg);
      payloadData = parsed;
      msg = parsed?.message ?? msg;
    } catch {
      // plain text progress
    }
  }
  return {
    payloadData,
    displayMessage: typeof msg === 'string' ? msg : (msg?.message ?? ''),
    isCompleted: getCompletedFromData(data, typeof data?.message === 'object' ? data.message : payloadData),
  };
};

export const isEntryWebSocketReady = () => {
  const socket = getSocketClient();
  if (!socket?.subscribe) return false;
  if (typeof socket.isConnected === 'function' && !socket.isConnected()) return false;
  return true;
};

export const getDisplayMessage = (data) =>
  data?.errorMessage || data?.aiMessage || data?.message;

export const parseAsyncHttpEnvelope = (httpResponse) => {
  const resData = httpResponse?.data || {};
  const eventMessage = resData?.eventMessage || resData;
  const completed = eventMessage?.completed ?? resData?.completed;
  return { resData, eventMessage, completed };
};

export const waitForAsyncJob = (requestId, { onProgress, onComplete, onError, timeoutErrorMessage }) =>
  new Promise((resolve, reject) => {
    let unsubscribe = () => {};
    const cleanup = () => {
      unsubscribe();
      onProgress('');
    };
    const timeoutMsg = timeoutErrorMessage || 'Async request timed out.';
    const timeoutId = setTimeout(() => {
      cleanup();
      const err = new Error(timeoutMsg);
      onError(err.message);
      reject(err);
    }, ASYNC_WS_TIMEOUT_MS);

    try {
      if (!isEntryWebSocketReady()) {
        clearTimeout(timeoutId);
        onError('WebSocket not available for progress updates.');
        reject(new Error('WebSocket not available for progress updates.'));
        return;
      }
      const socket = getSocketClient();
      unsubscribe = socket.subscribe(requestId, (data) => {
        const { payloadData, displayMessage, isCompleted } = normalizeWsPayload(data);
        if (displayMessage) onProgress(displayMessage);
        if (!isCompleted) return;

        clearTimeout(timeoutId);
        cleanup();
        const result = onComplete(payloadData);
        if (result.error) {
          onError(result.error);
          reject(new Error(result.error));
        } else {
          resolve(result.payload);
        }
      });
    } catch (err) {
      clearTimeout(timeoutId);
      onError(err?.message);
      reject(err);
    }
  });
